export class TimeFrameTypeDto {
    /**
     * Is selected by the user for the time frame list table value to be used.  The default
     * value should be SystemGuid.TimeFrame_Default, which is the "_" to be replaced with
     * any text the user types.
     */
    Id: string;

    /**
     * Assigned my the user as the replacement text for the underline character. For
     * example "number days sick _"; where the "_" is replaced with the user's input.
     * Can be any characters not just numbers.
     */
    Value: string;

    /** This should be read only and is assigned by the TimespanControlProperties */
    Answer: string;

    /** This value is the Fuzzy Date value and should be read only and is assigned by the TimespanControlProperties */
    Date: string;
}
